export default "__VITE_ASSET__14bce317__"